import React from 'react'

export default () => (
  <svg
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 408.59 401.32"
  >
    <g id="Layer_1-2">
      <g>
        <path
          fill="#11181c"
          d="M72.79,191.41c-.02-14.11,.12-27.76,.15-41.42,.05-16.83,.01-33.66,.01-51.08h-13.99v-23.94c7.82,0,15.68-.7,23.35,.19,8.49,.98,14.59,9.04,15.15,18.05,.1,1.66,.04,3.33,.04,5,0,76.32,0,152.65,0,228.97,0,26.47,18.36,46.96,44.37,49.53,24.58,2.43,47.12-14.61,52.14-39.73,4.92-24.61-14.43-58.56-49.26-53.7v26.58h13.65v23.88c-5.64,0-11.31,.51-16.85-.1-12.5-1.39-21.23-11.82-21.56-25.31-.2-8.16-.21-16.34,0-24.5,.41-15.81,9.56-24.97,25.38-25.35,8.99-.22,18-.04,27-.04,53.66,0,107.32,.08,160.98-.05,16.62-.04,31.94,3.76,45.9,13.63,14.04,11.2,23.76,24.87,27.59,42.36,9.76,44.52-22.75,86.45-68.41,86.74-65.81,.42-131.63,.21-197.44-.53-27.21-.31-48.83-11.91-61.35-37.28-5.19-10.5-6.67-21.88-6.68-33.46-.05-45.99-.04-91.98-.17-138.43m141.3,164.39c-3.67,6.79-7.33,13.59-11.22,20.79,1.54,0,3,0,4.46,0,42.99,.11,85.99,.24,128.98,.33,2.49,0,5.02,0,7.47-.38,24.78-3.76,42.07-24.83,40.48-49.62-1.66-25.73-22.02-43.92-47.98-43.95-43.16-.05-86.33-.02-129.49,0-1.2,0-2.41,.19-3.9,.32,15.76,22.38,20.5,46.02,11.2,72.51Z"
        />
        <path
          fill="#11181c"
          d="M379.54,252.32c-7.86-2.41-15.74-5.29-24.19-8.37v-5.23c0-66.45,0-132.91,0-199.36,0-11.1-3.81-14.89-15.04-14.89-79.95,0-159.89,0-239.84,0-31.26,0-58.22,17.38-69.88,45.06-11.71,27.81-5.46,58.26,16.63,80.95,1.63,1.67,3.2,3.41,4.96,4.93,4.5,3.9,6.31,8.76,4.15,14.31-2.19,5.62-6.87,7.84-13.26,7.39-7.42-6.26-15.48-11.72-21.22-19.01C-1.55,128.39-6.23,95.07,8.17,60.43,22.58,25.82,49.55,5.9,86.98,.83,91.74,.18,96.61,.04,101.43,.04,180.93-.01,260.42,0,339.92,0c24.68,0,39.59,14.83,39.59,39.36,0,70.83,0,141.66,.03,212.96Z"
        />
        <path
          fill="#11181c"
          d="M187.67,135.78c40.81,0,81.12,0,121.43,0,6.78,0,10.71,2.35,12.78,7.49,2.96,7.37-1.56,15.28-9.46,16.49-1.14,.17-2.33,.12-3.49,.12-55.3,0-110.61,0-165.91,0-1.15,0-2.29-.1-3.74-.17v-23.93h48.39Z"
        />
        <path
          fill="#11181c"
          d="M246.67,192.41c12.66,0,24.82-.12,36.98,.04,9.39,.12,14.84,6.32,13.2,14.59-1,5.06-4.83,8.71-10.24,9.54-1.8,.28-3.65,.21-5.48,.21-45.47,0-90.94,0-136.41,0h-5.38v-24.39c35.64,0,71.23,0,107.33,0Z"
        />
        <path
          fill="#11181c"
          d="M278.61,78.87c2.15,0,3.82-.02,5.48,0,7.79,.11,13.02,4.92,13.06,12,.05,7.06-5.24,12.04-12.99,12.06-16.65,.04-33.29,.01-49.94,.01h-95.01v-24.07h139.39Z"
        />
      </g>
    </g>
  </svg>
)
